import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';

interface BaseStatusDropdownButtonProps {
  buttonStyle: ButtonStyle;
  menuOptions: Array<JSX.Element>;
  disabled?: boolean;
  className?: string;
}

export default function BaseStatusDropdownButton({
  buttonStyle,
  menuOptions,
  disabled,
  className,
}: BaseStatusDropdownButtonProps): JSX.Element {
  function getMenu(): JSX.Element {
    return (
      <Menu
        height={Menu.HEIGHTS.MEDIUM}
        width={Menu.WIDTHS.FIT_CONTENT}
        useSelectedIconIfSingleSelect={false}
        dropLeft={true}
      >
        {menuOptions}
      </Menu>
    );
  }

  return (
    <Dropdown
      menu={getMenu()}
      {...getTestProps({component: 'BaseStatusDropdownButton', element: 'dropdown'})}
    >
      <Button
        className={className}
        icon="caret-down"
        isDropdown={false}
        buttonStyle={buttonStyle}
        disabled={disabled}
        size={ButtonSize.MEDIUM}
        dataTestAttrs={{component: 'BaseStatusDropdownButton', element: 'button'}}
      />
    </Dropdown>
  );
}
